'use strict';

window.docsUtils = {};

/*
 *
 * @param array
 * @param name of the date variable
 * @param order -> descending = -1 or ascending = 1
 * @return sorted array by date
 */
docsUtils.sortByDate = function (array, name, order) {
    order = order || 1;

    var sortedArray = angular.copy(array);
    sortedArray.sort(function (a, b) {
        return order * (moment(b[name]) - moment(a[name]));
    });

    return sortedArray;
};

docsUtils.isDateExpired = function (date) {
    return moment(date).isSameOrBefore(moment(), 'day');
};